import { useContext, type ReactNode } from 'react';

import { HistogramChartConfigContext } from '../contexts/HistogramChartConfig.context.js';
import type {
  HistogramChartConfiguration,
  HistogramChartConfigProps,
} from '../types/histogram-props.js';
import {
  createHistogramConfiguration,
  deserializeConfig,
} from '../utils/histogram-configuration.js';
import { iterateSlots } from '../utils/iterate-slots.js';

export const useHistogramChartConfig = (
  children?: ReactNode,
  overrides?: HistogramChartConfigProps,
): HistogramChartConfiguration => {
  const contextConfig = useContext(HistogramChartConfigContext);
  const slots = iterateSlots(children);
  const isImportedConfig = typeof contextConfig === 'string';
  const config = isImportedConfig
    ? deserializeConfig(contextConfig)
    : contextConfig;

  return createHistogramConfiguration(slots, config, overrides || {});
};
